import React from 'react';
import PropTypes from 'prop-types';

const ReactTableFooter = ({ footerGroups, useActions }) => (
  <tfoot className="tfoot">
    {footerGroups.map(group => (
      <tr {...group.getFooterGroupProps()}>
        {group.headers.map(column => (
          <td {...column.getFooterProps()}>{column.render('Footer')}</td>
        ))}
        {useActions?<td></td>: null}
      </tr>
    ))}
  </tfoot>
);

ReactTableFooter.propTypes = {
  footerGroups: PropTypes.arrayOf(PropTypes.shape({
    headers: PropTypes.arrayOf(PropTypes.shape()),
    getFooterGroupProps: PropTypes.func,
  })).isRequired,
  useActions: PropTypes.bool,
};

export default ReactTableFooter;
